import { createContext } from 'react';
import { ChartType } from '~/types';

export const ChartContext = createContext<ChartType | undefined>(undefined);
